import { render, staticRenderFns } from "./Textcentered.vue?vue&type=template&id=06d2d3ad&"
import script from "./Textcentered.vue?vue&type=script&lang=js&"
export * from "./Textcentered.vue?vue&type=script&lang=js&"
import style0 from "./Textcentered.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports